module.exports = __webpack_public_path__ + "img/coupon-line.8be72333.svg";